import { useState, useEffect } from "react";
import { message, Form, Spin } from "antd";
import styled from "styled-components";
import { GroupOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Search from "components/inputs/Search";
import NumberInput from "components/inputs/NumberInput";
import Select, { Cascader } from "components/inputs/Select";
import Fetch from "components/Fetch";
import { StyledModal } from "components/App/styled";
export default function App({
  buttonStyle = {},
  data,
  reload,
  categories,
  brands,
}) {
  const [form] = Form.useForm();

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [needsReload, setNeedsReload] = useState(false);
  const [products, setProducts] = useState(data.products);
  const [brand, setBrand] = useState("همه");
  const [category, setCategory] = useState(["همه"]);

  const showModal = () => {
    setVisible(true);
  };

  const onSubmit = (submitData) => {};
  const handleChange = (type, index, newValue) => {
    try {
      const selected = products[index];

      setLoading(index);
      Fetch.put(`/products/${selected.id}`, { [type]: newValue }, (res) => {
        console.log("new product response/ UPDATE", res);
        if (res?.ok) {
          message.success("با موفقیت آپدیت شد");
          console.log(1123, visible);
          if (!needsReload) {
            setNeedsReload(true);
          }

          // reload(true);
        } else {
          if (res?.errors?.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
        setLoading(false);
      });
    } catch (error) {
      message.error("خطایی رخ داده است");
    }
  };
  // apply filters on change :::
  useEffect(() => {
    var newProducts = data.products;

    if (category?.[0] !== "همه") {
      newProducts = newProducts.filter(
        (item) => item.category === category.join("-")
      );
    }
    if (brand !== "همه") {
      newProducts = newProducts.filter((item) => item.brand === brand);
    }
    setProducts(newProducts);
  }, [brand, category, data.products]);

  useEffect(() => {
    if (!visible && needsReload) {
      reload();
      setNeedsReload(false);
    }
  }, [visible, needsReload]);

  function handleSearch({ target }) {
    const { value } = target;
    var newProducts = [...data.products];
    if (value) {
      newProducts = newProducts.filter(
        (item) => item.title.includes(value) && item
      );
      console.log("searched.");
    }
    setProducts(newProducts);
  }

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Container>
      <Button
        shape="round"
        color={colors.dark}
        size="middle"
        onClick={showModal}
        style={{ borderRadius: 24, ...buttonStyle }}
      >
        <span>
          <GroupOutlined style={{ marginLeft: 8 }} />
          به روز رسانی گروهی
        </span>
      </Button>
      <StyledModal
        title={"به روز رسانی گروهی"}
        visible={visible}
        onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        onChange={(v) => setVisible(v)}
        footer={[
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleCancel}
            style={{ width: "100%" }}
            color={colors.blue}
          >
            بستن
          </Button>,
        ]}
        width={980}
      >
        <Search
          placeholder="جستجو..."
          onChange={handleSearch}
          style={{ marginBottom: 20, marginTop: -10, borderRadius: 6 }}
        />
        <FilterContainer>
          <Cascader
            title="دسته بندی"
            placeholder="همه"
            options={[{ value: "همه", label: "همه" }, ...data.sortedCategories]}
            showSearch={{ filter }}
            optionFilterProp="children"
            onChange={(value) => setCategory(value)}
            allowClear={false}
          />
          <Select
            title="برند"
            list={[{ title: "همه" }, ...brands]}
            borderradius={"6px"}
            showSearch
            placeholder="جستجو"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(value) => setBrand(value)}
            key="brand2"
          />
        </FilterContainer>
        <Form
          form={form}
          layout="vertical"
          style={{ direction: "rtl", overflow: "auto" }}
          //   requiredMark={requiredMark}
          onFinish={onSubmit}
        >
          <>
            <ColContainer style={{ fontWeight: "bold" }}>
              <Col style={{ minWidth: 80, width: 80, flex: 1 }}>کد</Col>
              <Col style={{ flex: 6 }}>عنوان کالا</Col>
              <Col style={{ flex: 2 }}>تعداد</Col>
              <Col style={{ flex: 2 }}>قیمت</Col>
            </ColContainer>
            {products.map((item, key) => (
              <Spin spinning={loading ? loading === key : false} key={key}>
                <ColContainer>
                  <Col style={{ minWidth: 80, width: 80, flex: 1 }}>
                    {item.code}
                  </Col>
                  <Col style={{ flex: 6 }}>{item.title}</Col>
                  <Col style={{ flex: 2 }}>
                    <NumberInput
                      defaultValue={item.stock}
                      onBlur={(e) =>
                        handleChange("stock", key, Number(e.target.value))
                      }
                    />
                  </Col>
                  <Col style={{ flex: 2 }}>
                    <NumberInput
                      defaultValue={item.price}
                      onBlur={(e) =>
                        handleChange("price", key, Number(e.target.value))
                      }
                    />
                  </Col>
                </ColContainer>
              </Spin>
            ))}
          </>
        </Form>
      </StyledModal>
    </Container>
  );
}

const filter = (inputValue, path) =>
  path.some(
    (option) =>
      option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
const ColContainer = styled.div`
  display: flex;
  color: ${colors.dark};
  gap: 12px;
  @media (max-width: 480px) {
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  padding: 8px 0;

  & .ant-input-number {
    width: 90%;
  }
  @media (max-width: 420px) {
    min-width: 120px;
    font-size: 13px;
  }
`;
const Container = styled.div`
  display: inline-flex;
`;
const FilterContainer = styled.div`
  display: flex;
  margin-bottom: 48px;
  & > div:nth-child(2) {
    margin-right: 24px;
  }
  @media (max-width: 420px) {
    flex-direction: column;
    & > div:nth-child(2) {
      margin-right: 0;
    }
  }
`;
